<template>
  <el-dialog
    :title="title"
    :visible="visible"
    width="72%"
    append-to-body
    @close="handleClose"
  >
    <div style="height: 360px; overflow-y: scroll">
      <el-table
        size="small"
        :data="data"
        highlight-current-row
        border
        element-loading-text="拼命加载中"
        style="width: 100%"
      >
        <el-table-column align="center" label="操作" width="120">
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="danger"
              @click="handleDelete(scope.index)"
              >删除</el-button
            >
          </template>
        </el-table-column>
        <el-table-column
          sortable
          prop="moneyOrderCode"
          width="120px"
          label="票据号码"
        >
          <template slot-scope="props">
<!--            <el-tooltip-->
<!--              effect="dark"-->
<!--              :content="props.row.moneyOrderCode"-->
<!--              placement="top-start"-->
<!--            >-->
              <span
                >......<span>{{
                  props.row.moneyOrderCode.slice(-9)
                }}</span></span
              >
<!--            </el-tooltip>-->
          </template>
        </el-table-column>
        <el-table-column
          sortable
          prop="customerName"
          label="客户名称"
          width="140px"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          sortable
          prop="acceptorName"
          label="承兑人"
          width="140px"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          sortable
          prop="faceValue"
          label="票面金额（万）"
          show-overflow-tooltip
          align="center"
        >
          <template slot-scope="props">
            {{
              props.row.allCount > 1
                  ? `${props.row.faceValue} * ${props.row.allCount}张`
                  : props.row.outCount > 1 ? `${props.row.faceValue} * ${props.row.outCount}张` : props.row.faceValue
            }}
          </template>
        </el-table-column>
        <el-table-column
          sortable
          prop="dueDate"
          label="到期日期"
          show-overflow-tooltip
          :formatter="handleFormatDate"
        >
        </el-table-column>
        <el-row>
          <el-table-column label="进价（%）" prop="inPercentage">
            <template slot-scope="props">
              <el-input-number
                :min="0"
                :max="50"
                :controls="false"
                size="small"
                v-model="props.row.inPercentage"
                placeholder="进价（%）"
              ></el-input-number>
            </template>
          </el-table-column>
        </el-row>
      </el-table>
    </div>
    <span slot="footer">
      <div style="display: flex; flex-direction: column">
        <div style="align-self: flex-start; margin-bottom: 10px">
          <span style="margin-right: 15px">
            票面金额（万）<span style="font-weight: bold">{{
              faceAllValue
            }}</span>
          </span>
          <span style="margin-right: 15px">
            票面价值（万）<span style="font-weight: bold">{{
              allInValue
            }}</span>
          </span>
          <span>
            差值（万）<span style="font-weight: bold">{{
              allDifferencePrice
            }}</span>
          </span>
        </div>
      </div>
      <div>
        报价员：
          <el-autocomplete
            size="small"
            v-model="inBidder"
            :fetch-suggestions="querySearch"
            placeholder="输入内容自动匹配报价员"
            :trigger-on-focus="false"
            @select="handleConfirmSelectSaleman($event, 'inBidder')"
          >
            <template slot-scope="{ item }">
              <div>
                {{ item.realName + "（" + item.dept.deptName + "）" }}
              </div>
            </template>
          </el-autocomplete>
        业务员：
        <el-autocomplete
          size="small"
          v-model="inSalesman"
          :fetch-suggestions="querySearch"
          placeholder="输入内容自动匹配业务员"
          :trigger-on-focus="false"
          @select="handleConfirmSelectSaleman($event, 'inSalesman')"
        >
          <template slot-scope="{ item }">
            <div>
              {{ item.realName + "（" + item.dept.deptName + "）" }}
            </div>
          </template>
        </el-autocomplete>
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="handleSubmit" v-if="submitButton">确 定</el-button>
      </div>
    </span>
  </el-dialog>
</template>

<script>
import { updateBatchStoreTicket } from "@/api/ticket/ticket";
import { listSalesman } from "@/api/system/user";
import { timestampToDate } from "@/utils";

export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Array,
      default: () => [],
    },
    title: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      allInValue: 0,
      faceAllValue: 0,
      allDifferencePrice: 0,
      inSalesman: null,
      inSalesmanId: null,
       inBidder: null,
      inBidderId: null,
      submitButton: true
    };
  },
  methods: {
    handleDelete(index) {
      this.data.splice(index, 1);
    },
    handleFormatDate(row, column, cellValue) {
      if (cellValue) {
        return timestampToDate(cellValue);
      }
      return cellValue;
    },
    querySearch(name, call) {
      listSalesman(name)
        .then((list) => {
          call(list);
          if (list.length <= 0) {
            this.$message.warning("不存在该业务员");
          }
        })
        .catch(this.$message.error);
    },
    handleConfirmSelectSaleman(data, type) {
      if (data) {
        if (type === "inSalesman") {
          this.inSalesman = data.realName;
          this.inSalesmanId = data.id;
        }
        if (type === "inBidder") {
          this.inBidder = data.realName;
          this.inBidderId = data.id;
        }
      }
    },
    handleSubmit() {
      if (this.data.length) {
        if (!this.inSalesman) {
          this.$message.warning("业务员是必填属性");
          return;
        }

        updateBatchStoreTicket({
          orderList: this.data.map((item) => {
            item.inSalesman = this.inSalesman;
            item.inSalesmanId = this.inSalesmanId;
            item.inBidder = this.inBidder;
            item.inBidderId = this.inBidderId;
            return item;
          }),
          inArrears: this.inArrears,
          outArrears: this.outArrears,
        })
          .then((data) => {
            const { allInValue, faceAllValue, allDifferencePrice } = data;
            this.allInValue = allInValue;
            this.faceAllValue = faceAllValue;
            this.allDifferencePrice = allDifferencePrice;
             this.submitButton = false;
            this.$message.success("操作成功");
          })
          .catch(this.$message.warning);
      } else {
        this.$message.warning("不存在编辑数据，无法批量更新！");
      }
    },
    handleClose() {
      this.$emit("update:visible", false);
      this.$emit("confirm");
      this.allInValue = 0;
      this.faceAllValue = 0;
      this.allDifferencePrice = 0;
      this.inSalesman = null;
      this.inSalesmanId = null;
      this.inBidder = null;
      this.inBidderId = null;
      this.submitButton = true;

    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/ticket/ticket-store/batch.vue